/**
 * Logo — Safe + Tick mark.
 *
 * Inline SVG so we avoid an extra HTTP request and can re-theme via CSS if
 * needed. Keep this in sync with /public/logo.svg.
 *
 * Designed to read at every size: chunky dial + bold hinges survive thumbnail
 * scaling. Favicon (/public/favicon.svg) drops the dial — at 16-32px it's too
 * small to add value.
 */

interface Props {
  size?: number;
  className?: string;
  decorative?: boolean;
}

export function Logo({ size = 48, className, decorative = false }: Props) {
  const a11y = decorative
    ? { 'aria-hidden': true as const, role: 'presentation' as const }
    : { role: 'img' as const, 'aria-label': 'Safe and Sorted' };

  return (
    <svg
      viewBox="0 0 64 64"
      width={size}
      height={size}
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...a11y}
    >
      <rect x="6" y="9" width="52" height="46" rx="6" fill="#0F172A" />
      <circle cx="16" cy="22" r="3" fill="#FFFFFF" />
      <circle cx="16" cy="22" r="1" fill="#0F172A" />
      <rect x="52" y="18" width="3" height="6" rx="0.6" fill="#FFFFFF" />
      <rect x="52" y="40" width="3" height="6" rx="0.6" fill="#FFFFFF" />
      <path
        d="M22 35 L29 42 L44 24"
        stroke="#22C55E"
        strokeWidth="6.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  );
}

export function Wordmark({ size = 48 }: { size?: number }) {
  return (
    <div className="brand-wordmark">
      <Logo size={size} decorative />
      <span className="brand-wordmark-text">
        <span className="brand-wordmark-strong">Safe</span>
        <span className="brand-wordmark-and">and</span>
        <span className="brand-wordmark-strong">Sorted</span>
      </span>
    </div>
  );
}
